import React from "react";
import { connect } from "react-redux";

import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import Activity from "@mapmycustomers/shared/types/entity/Activity";

import EntityBlock from "@app/component/frequency/EntityBlock";
import FrequencyCollapsePanel from "@app/component/frequency/FrequencyCollapsePanel";
import FrequencyPreview from "@app/component/frequency/FrequencyPreview";
import FrequencyEntity from "@app/component/frequency/type/FrequencyEntity";
import {
  getFrequencyModalConfig,
  getLastFrequencyActivity,
  isFrequencyModalLoading,
} from "@app/store/frequency";
import { RootState } from "@app/store/rootReducer";
import layout from "@app/styles/layout";
import useToggleBooleanAfterTimeout from "@app/util/hook/useToggleBooleanAfterTimeout";

import styles from "./FrequencyBlock.module.scss";

interface Props {
  entity: FrequencyEntity;
  lastFrequencyActivity?: Activity;
  loading: boolean;
  onCancel: () => void;
}

const NewFrequency = ({ entity, lastFrequencyActivity, loading, onCancel }: Props) => {
  const intl = useIntl();
  const showLoading = useToggleBooleanAfterTimeout(1000, false, loading, true);

  return (
    <div className={styles.container}>
      <FrequencyCollapsePanel
        header={
          <Row align="middle" gutter={layout.spacerM}>
            <Col>
              {intl.formatMessage({
                id: "frequency.frequencyModal.frequencies.newFrequency.title",
                defaultMessage: "Specific to:",
                description:
                  "frequency component - frequency modal - frequencies - new frequency - title",
              })}
            </Col>
            <Col>
              <EntityBlock entity={entity} />
            </Col>
          </Row>
        }
        isOpenByDefault
      >
        <FrequencyPreview
          entity={entity}
          lastCompletedActivity={lastFrequencyActivity}
          loading={showLoading}
          onCancel={onCancel}
          showSaveButtonsOnlyAfterChanges
        />
      </FrequencyCollapsePanel>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  entity: getFrequencyModalConfig(state).entity,
  lastFrequencyActivity: getLastFrequencyActivity(state),
  loading: isFrequencyModalLoading(state),
});

export default connect(mapStateToProps)(NewFrequency);
